<template>
<section class="input-container">
    <div class="label">
        <p><i class="icon-required" v-if="transProp.validations.presence === '1'">*</i>{{transProp.label}}:</p>
        <van-icon name="question-o" class="question" v-if="transProp.notes" @click="showNotes" />
    </div>
    <div class="inp-f">
        <input type="text" class="inp-s" v-model="value" @input="validate" name="">
    </div>
    <div class="form-error" v-show="showError">
        {{setErrorMsg(transProp)}}
    </div>
</section>
</template>

<script>
import { Icon } from "vant";
export default {
  props: {
    transProp: Object,
    index: Number
  },
  components: {
    "van-icon": Icon
  },
  data() {
    return {
      value: "",
      showError: false,
      errorMsg: this.transProp,
      marks: new Map([
          ['a72207a2e578e54537766d8d215e8d6f', 'pname'],
          ['c18a08139b496dc0c24a3f149603d72d', 'gname'],
          ['8a928eb6143188cfea4a4bf7c18aa8b5', 'sname'],
          ['43b561123d41f25e1aa0322468fd38a1', 'username'],
      ]),
    };
  },
  created() {
    if (this.transProp.mark) {
      let mark = this.marks.get(this.transProp.mark);
      this.value = this.$route.query[mark];
    }
  },
  methods: {
    showNotes() {
      this.$emit("input", this.index);
    },
    setErrorMsg(t) {
      return t.rules ? t.rules.message : `${t.label}不可为空`;
    },
    // 提交时拿取当前参数
    collectOptions() {
      let options = {
        code: this.transProp.code,
        value: this.value
      };
      return options;
    },
    validate() {
      if (this.transProp.rules) {
        if (!this.transProp.rules.pattern.test(this.value)) {
          this.showError = true;

          return { label: this.transProp.label, boo: true };
        }
        this.showError = false;
        return { label: this.transProp.label, boo: false };
      } else if (this.transProp.required) {
        if (!this.value) {
          this.showError = true;

          return {
            label: this.transProp.label,
            boo: true
          };
        } else {
          this.showError = false;
          return {
            label: this.transProp.label,
            boo: false
          };
        }
      } else {
        return { label: this.transProp.label, boo: false };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .question {
      color: #999090;
      font-size: 32px;
    }
  }

  .inp-f {
    margin: 8px 0;

    .inp-s {
      color: #666;
    }
  }
}
</style>
